module.exports = __webpack_public_path__ + "img/sld_scb_37_t1_b1_green.e1f97a59.svg";